<template>
  <div class="w-full bg-gray-900 py-10 relative">

    <!-- Slide Menu  -->
    <transition name="slide">
    <div
      v-if="showSlideMenu" style="z-index: 999999999999999"
      class="fixed top-0 left-0 z-50 h-screen w-full flex justify-end"
    >
      <div
        class="p-10 h-screen w-11/12 bg-secondary text-white text-left relative overflow-y-auto"
      >
        <div class="absolute top-0 right-0 m-2">
          <svg
            @click="showSlideMenu = false"
            class="w-8 h-8 cursor-pointer hover:text-primary cursor-pointer"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </div>
        <h2 class="text-white header-bold text-xl text-gray-400 mt-10">
          {{ currentUser.role === 'admin' ? 'Admin' : 'Team Leader' }}
        </h2>
        <div class="w-full mt-4 flex flex-wrap">

          <!-- Team Leader menu items (shown only for team leaders who are not admins) -->
          <template v-if="currentUser.isTeamLeader && currentUser.role !== 'admin'">
            <div @click="navigateMenu({name: 'Tracker'})"
              class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
              <i class="fa-solid fa-map-location-dot text-primary mr-3 w-5 text-center"></i>
              Team Tracker
              <svg class="ml-auto w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
            <div @click="logout()"
              class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4 mt-4 border-t border-gray-700 pt-4">
              <i class="fa-solid fa-right-from-bracket text-gray-400 mr-3 w-5 text-center"></i>
              Logout
            </div>
          </template>

          <!-- Admin menu items -->
          <template v-if="currentUser.role === 'admin'">

          <!-- Dashboard (direct) -->
          <div @click="navigateMenu({name: 'DashboardOverview'})"
            class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
            <i class="fa-solid fa-gauge-high text-primary mr-3 w-5 text-center"></i>
            Dashboard
            <svg class="ml-auto w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>

          <!-- CRM (direct) -->
          <div @click="navigateMenu({name: 'Crm'})"
            class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
            <i class="fa-solid fa-bolt text-primary mr-3 w-5 text-center"></i>
            CRM
            <svg class="ml-auto w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>

          <!-- Scheduling (accordion) -->
          <div class="w-full">
            <div @click="toggleSection('scheduling')"
              class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
              <i class="fa-regular fa-clock text-primary mr-3 w-5 text-center"></i>
              Scheduling
              <i :class="['fa-solid ml-auto text-gray-400 text-sm transition-transform', expandedSection === 'scheduling' ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
            </div>
            <div v-show="expandedSection === 'scheduling'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
              <div @click="navigateMenu({name: 'Home'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-regular fa-clock text-primary mr-3 w-4 text-center text-sm"></i>
                Job Schedule
              </div>
              <div @click="navigateMenu({name: 'AiPlanner'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-wand-magic-sparkles text-primary mr-3 w-4 text-center text-sm"></i>
                AI Planner
              </div>
              <div @click="navigateMenu({name: 'AiAssistant'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-robot text-primary mr-3 w-4 text-center text-sm"></i>
                AI Assistant
              </div>
              <div @click="navigateMenu({name: 'Timesheets'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-clock text-primary mr-3 w-4 text-center text-sm"></i>
                Timesheets
              </div>
            </div>
          </div>

          <!-- Fleet (accordion) -->
          <div class="w-full">
            <div @click="toggleSection('fleet')"
              class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
              <i class="fa-solid fa-truck text-primary mr-3 w-5 text-center"></i>
              Fleet
              <i :class="['fa-solid ml-auto text-gray-400 text-sm transition-transform', expandedSection === 'fleet' ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
            </div>
            <div v-show="expandedSection === 'fleet'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
              <div @click="navigateMenu({name: 'Tracker'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-map-location-dot text-primary mr-3 w-4 text-center text-sm"></i>
                Tracker
              </div>
              <div @click="navigateMenu({name: 'Fleet'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-truck text-primary mr-3 w-4 text-center text-sm"></i>
                Fleet
              </div>
            </div>
          </div>

          <!-- Clients (accordion) -->
          <div class="w-full">
            <div @click="toggleSection('clients')"
              class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
              <i class="fa-solid fa-user-group text-primary mr-3 w-5 text-center"></i>
              Clients
              <i :class="['fa-solid ml-auto text-gray-400 text-sm transition-transform', expandedSection === 'clients' ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
            </div>
            <div v-show="expandedSection === 'clients'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
              <div @click="navigateMenu({name: 'ClientBook'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-user-group text-primary mr-3 w-4 text-center text-sm"></i>
                Client Book
              </div>
              <div @click="navigateMenu({name: 'ClientLog'})"
                class="w-full flex items-center h-10 text-gray-300 text-base hover:text-primary cursor-pointer px-8">
                <i class="fa-solid fa-headset text-primary mr-3 w-4 text-center text-sm"></i>
                Call Log
              </div>
            </div>
          </div>

          <!-- Users (direct) -->
          <div @click="navigateMenu({name: 'Users'})"
            class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4">
            <i class="fa-solid fa-user-shield text-primary mr-3 w-5 text-center"></i>
            Users
            <svg class="ml-auto w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>

          <!-- Logout -->
          <div @click="logout()"
            class="w-full flex items-center h-12 text-white text-lg hover:text-primary cursor-pointer px-4 mt-4 border-t border-gray-700 pt-4">
            <i class="fa-solid fa-right-from-bracket text-gray-400 mr-3 w-5 text-center"></i>
            Logout
          </div>

          </template>
        </div>
      </div>
    </div>
    </transition>
    <!-- Finish slide menu  -->
    <div
    :class="currentUser.role == 'admin' ? ' m-6' : 'text-center w-full mt-6'"
    class="absolute top-0 left-0 text-white header-bold">Welcome to KCT Job Board
      <div v-if="todayStartTime && currentUser.role !== 'admin'" class="text-sm text-purple-300 mt-1 font-normal">
        <i class="fa-solid fa-clock mr-1"></i>Start Time: <span class="font-bold">{{ todayStartTime }}</span>
      </div>
    </div>

    <div class="absolute top-0 right-0 m-4 flex items-center space-x-3">
      <button v-if="currentUser.role !== 'admin' && !currentUser.isTeamLeader" @click="logout()"
        class="text-gray-400 hover:text-white transition-colors"
        title="Logout">
        <i class="fa-solid fa-right-from-bracket text-lg"></i>
      </button>
      <svg v-if="currentUser.role == 'admin' || currentUser.isTeamLeader"
        @click="showSlideMenu = true"
        class="w-6 h-6 text-white cursor-pointer"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 10h16M4 14h16M4 18h16"
        ></path>
      </svg>
    </div>

    <div class="flex w-full items-center px-10 mt-10">
      <div class="flex-shrink bg-gray-700 rounded-l text-white w-20 h-20 flex items-center justify-center" @click="previousDate()">
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <div class="flex-grow" v-if="date">
            <flat-pickr
              class=" text-center text-lg h-20 bg-gray-800 outline-none px-2 text-gray-300"
              :config="config"
              v-model="date"
            ></flat-pickr>
      </div>
      <div class="bg-gray-700 rounded-r  flex-shrink text-white w-20 h-20 flex items-center justify-center" @click="nextDate()">
        <i class="fa-solid fa-chevron-right"></i>
      </div>
    </div>

  </div>
</template>

<script>
import {signMeOut, getTodaysTimesheet} from "../../firestore/utils"
import { bus } from '../../main'
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  props: ['jobs'],
  data() {
    return {
      search: "",
      date: "",
      prevDate: "",
      showSlideMenu: false,
      expandedSection: null,
      todayStartTime: null,
      config: {
        enableTime: false,
        altInput: true,
        allowInput: false,
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  watch: {
    search(){
      bus.$emit("search", this.search);
    },
    date() {
      bus.$emit("changeDate", {prevDate: this.prevDate, date: this.date});
    },
    prevDate() {
      bus.$emit("changeDate", {prevDate: this.prevDate, date: this.date});
    },
  },
  methods: {
    async logout(){
        await signMeOut()
        this.$router.push({name: 'Login'})
      },
    toggleSection(section) {
      this.expandedSection = this.expandedSection === section ? null : section;
    },
    nextDate() {
      this.date = this.$moment(this.date).add(1, "days").toISOString();
      this.prevDate = this.$moment(this.prevDate).add(1, "days").toISOString();
    },
    previousDate() {
      this.date = this.$moment(this.date).subtract(1, "days").toISOString();
      this.prevDate = this.$moment(this.prevDate).subtract(1, "days").toISOString();
    },
    togglePage(i) {
      bus.$emit("togglePage", { state: i });
    },
    toggleExport(){
      bus.$emit("triggerExport", true)
    },
    toggleImport() {
      bus.$emit("showImportProjectFunc");
    },
    navigateMenu(i) {
      this.showSlideMenu = false;
      this.$router.push({name: i.name})
      this.showSlideMenu = false;
    },
    toggleView() {
      bus.$emit("toggleMapView");
    },
  },

  components: {
    datetime: Datetime,
    flatPickr
  },
  async created() {
    console.log("jobs!", this.jobs)
    this.date = this.$moment().add(11, "hours").toISOString();
    this.prevDate = this.$moment().add(11, "hours").toISOString();

    // Load today's timesheet for contractor start time
    if (this.currentUser && this.currentUser.id && this.currentUser.role !== 'admin') {
      try {
        const ts = await getTodaysTimesheet(this.currentUser.id);
        if (ts && ts.scheduledStart) {
          this.todayStartTime = ts.startOverride || ts.scheduledStart;
        }
      } catch (e) {
        console.error('Error loading timesheet:', e);
      }
    }

    // Fallback: check testerStartTime from job documents once loaded
    bus.$on('jobs', (data) => {
      if (!this.todayStartTime && this.currentUser && this.currentUser.role !== 'admin') {
        const jobs = Array.isArray(data) ? data : Object.values(data).flatMap(g => g.jobs || []);
        const jobWithStart = jobs.find(j => j.testerStartTime);
        if (jobWithStart) {
          this.todayStartTime = jobWithStart.testerStartTime;
        }
      }
    });
  },
};
</script>

<style lang="postcss">
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(200%, 0);
}
</style>
